import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FeatureFlagDirective, UserPermissionsDirective } from '@bn/auth/directives';
import { LoadingComponent } from '@bn/web-ui/loading/loading.component';
import { MenuItem } from '../models';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';

@Component({
  standalone: true,
  selector: 'bn-layout-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss'],
  imports: [
    NgClass,
    RouterLink,
    RouterLinkActive,
    FaIconComponent,
    TooltipModule,
    FeatureFlagDirective,
    UserPermissionsDirective,
    LoadingComponent,
    BadgeComponent,
  ],
})
export class SubMenuComponent {
  @Input()
  public menuItems: MenuItem[] = [];

  @Input()
  public isLoading = false;
}
